import { Log, LogCategory } from '@augloop/logging';
export class BufferingSequencer {
    constructor(bufferingTimeMs = 500, rejectOutdatedSequenceNumbers = false) {
        this.prevSeq = -1;
        this.bufferingTimeMs = bufferingTimeMs;
        this.rejectOutdatedSequenceNumbers = rejectOutdatedSequenceNumbers;
    }
    sequence(seq) {
        return new Promise((resolve, reject) => {
            if (seq < this.prevSeq) {
                // sequence was reset or significantly delayed annotation arrived
                if (this.rejectOutdatedSequenceNumbers) {
                    const error = new Error(`BufferingSequencer: Item out of order. Expecting seqId > ${this.prevSeq}. Actual seqId ${seq}`);
                    error.name = BufferingSequencer.Rejected;
                    reject(error);
                    return;
                }
                else {
                    this.prevSeq = -1;
                }
            }
            if (seq != this.prevSeq + 1) {
                Log.warn(0x20592241 /* tag_6wsjb */, LogCategory.CoreDefault, `BufferingSequencer: got out of order sequence number. Got ${seq}, expected ${this.prevSeq + 1}`);
            }
            const item = { seq: seq, resolve: resolve };
            this.insertItem(item);
            this.runInOrder(item, true, false);
        });
    }
    insertItem(item) {
        if (!this.firstQueueItem) {
            this.firstQueueItem = item;
            this.lastQueueItem = item;
            return;
        }
        let currentItem = this.lastQueueItem;
        let prevItem = null;
        do {
            if (item.seq > currentItem.seq) {
                item.prev = currentItem;
                currentItem.next = item;
                if (prevItem) {
                    prevItem.prev = item;
                    item.next = prevItem;
                }
                else {
                    this.lastQueueItem = item;
                }
                return;
            }
            prevItem = currentItem;
            currentItem = currentItem.prev;
        } while (currentItem);
        if (prevItem) {
            prevItem.prev = item;
        }
        item.next = prevItem;
        this.firstQueueItem = item;
    }
    runInOrder(currentItem, scheduleDelayedProcessing, ignoreGapsForPreceedingElements) {
        let prevSeq = this.prevSeq;
        let currentItemResolved = false;
        const itemsToResolve = [];
        while (this.firstQueueItem) {
            const item = this.firstQueueItem;
            if (prevSeq + 1 != item.seq && (!ignoreGapsForPreceedingElements || item.seq > currentItem.seq)) {
                break;
            }
            prevSeq = item.seq;
            if (item.timeout) {
                clearTimeout(item.timeout);
            }
            itemsToResolve.push(item);
            if (currentItem == item) {
                currentItemResolved = true;
            }
            this.firstQueueItem = this.firstQueueItem.next;
            if (this.firstQueueItem) {
                this.firstQueueItem.prev = null;
            }
        }
        if (itemsToResolve.length > 0) {
            // setTimeout is needed here to fix an issue with incorrect order of promises continuations exectuion
            setTimeout(() => {
                for (const item of itemsToResolve) {
                    item.resolve(item.seq);
                }
            }, 0);
        }
        this.prevSeq = prevSeq;
        if (!currentItemResolved && scheduleDelayedProcessing) {
            currentItem.timeout = setTimeout(() => { this.runInOrder(currentItem, false, true); }, this.bufferingTimeMs);
        }
    }
}
BufferingSequencer.Rejected = 'SequenceItemRejected';
//# sourceMappingURL=buffering-sequencer.js.map